"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GoogleClusterMarker = exports.GoogleMapMarker = exports.SearchLocationMarker = exports.UserLocationMarker = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var UserLocationMarker = function UserLocationMarker() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "user-location-marker"
  });
};

exports.UserLocationMarker = UserLocationMarker;

var SearchLocationMarker = function SearchLocationMarker() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "search-location-marker"
  });
};

exports.SearchLocationMarker = SearchLocationMarker;

var GoogleMapMarker = function GoogleMapMarker(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "location-marker ".concat(props.selectedClass),
    onClick: props.onClick,
    role: "presentation"
  });
};

exports.GoogleMapMarker = GoogleMapMarker;

var GoogleClusterMarker = function GoogleClusterMarker(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "location-cluster-marker ".concat(props.points.length === 2 ? 'small' : 'big'),
    onClick: props.onClick,
    role: "presentation"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "counter"
  }, props.points.length));
};

exports.GoogleClusterMarker = GoogleClusterMarker;
GoogleMapMarker.propTypes = {
  selectedClass: _propTypes["default"].string.isRequired,
  onClick: _propTypes["default"].func.isRequired
};
GoogleClusterMarker.propTypes = {
  points: _propTypes["default"].arrayOf(_propTypes["default"].any).isRequired,
  onClick: _propTypes["default"].func.isRequired
};